import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { Colors, Shadows } from "../../../constants/Style";

export default makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      color: Colors.White,
      backgroundColor: Colors.Dark,
    },
    infoButton: {
      "&:hover": {
        backgroundColor: "unset",
        "& path:first-child": {
          fill: Colors.Primary,
        },
      },
    },
    infoTooltip: {
      backgroundColor: Colors.White,
      maxWidth: 500,
      width: 500,
      boxShadow: Shadows.BulkAction,
      padding: 0,
    },
  })
);
